import { apiGet } from './client';

export interface DashboardSparklines {
  retrievals_24h: number[];
  denied_24h: number[];
  principals_7d: number[];
  coverage_7d: number[];
}

export interface DashboardStats {
  retrievals_today: number;
  retrievals_allowed: number;
  retrievals_denied: number;
  connectors_connected: number;
  connectors_error: number;
  idps_connected: number;
  idps_principal_count: number;
  last_idp_sync: string | null;
  recent_denied: RecentDeniedRetrieval[];
  total_bound_vectors: number;
  total_vectors: number;
  overall_coverage_pct: number | null;
  connectors_policy_ready: number;
  sparklines: DashboardSparklines | null;
}

export interface RecentDeniedRetrieval {
  id: string;
  query: string;
  principal_name: string | null;
  denial_reason: string;
  timestamp: string;
}

export function getDashboardStats(): Promise<DashboardStats> {
  return apiGet<DashboardStats>('/dashboard/stats', { sparklines: 'true' });
}

export interface ActivationFunnelStats {
  orgs_with_connector: number;
  orgs_with_first_retrieval: number;
  orgs_with_active_policy: number;
  orgs_at_l3_or_above: number;
  total_retrievals_30d: number;
  allowed_retrievals_30d: number;
  denied_retrievals_30d: number;
  no_access_retrievals_30d: number;
  p95_latency_ms: number | null;
  days_since_signup: number | null;
  days_since_first_retrieval: number | null;
  days_to_first_active_policy: number | null;
}

export function getActivationStats(): Promise<ActivationFunnelStats> {
  return apiGet<ActivationFunnelStats>('/dashboard/activation');
}
